<template>
  <div class="page-wrapper">
    <commonHeader heading="学习力指标调研" subtitle="" addTitle="创建调研问卷" @callback="addClick()">
    </commonHeader>
    <div class="table-data">
      <v-card>
        <div class="table-header">
          <v-text-field class="text-field-width" v-model="queryParams.value1" placeholder="问卷名称" hide-details solo
            clearable></v-text-field>
          <v-text-field class="text-field-width" v-model="queryParams.value2" placeholder="创建人" hide-details solo
            clearable></v-text-field>

          <v-select class="select-width" v-model="queryParams.value3" :items="selectMetaListData" label="问卷类型"
            color="#4caf50" hide-details solo></v-select>

          <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field class="date-width" v-model="queryParams.date" hide-details solo readonly
                placeholder="创建时间" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker locale="zh-cn" v-model="queryParams.date" @input="dateMenu = false"></v-date-picker>
          </v-menu>
          <v-select class="select-width" v-model="queryParams.value3" :items="selectObjData" label="调研对象"
            color="#4caf50" hide-details solo></v-select>
          <v-btn depressed color="primary" @click="searchQuery">
            搜索
          </v-btn>
          <v-btn depressed @click="searchClear">
            清空
          </v-btn>
        </div>
        <div class="table-content">
          <v-data-table 
            hide-default-footer 
            :headers="tableHeader" 
            :items="tableList" 
            :items-per-page="5"
          >
            <template #[`item.name`]="{ item }">
              <a
                style="color: #9c27b0; cursor: pointer"
                >{{ item.name }}</a
              >
            </template>
            <template #[`item.option`]="{ item }">
              <v-btn
                icon
                color="primary"
                small
              >
                <span class="mdi mdi-share-all" style="font-size: 20px;"></span>
                <md-tooltip md-direction="top">分享</md-tooltip>
              </v-btn>
              <v-btn
                icon
                color="primary"
                small
              >
                <span class="mdi mdi-content-copy" style="font-size: 20px;"></span>
                <md-tooltip md-direction="top">复制</md-tooltip>
              </v-btn>
              <v-btn
                icon
                color="error"
                small
              >
                <span class="mdi mdi-trash-can-outline" style="font-size: 20px;"></span>
                <md-tooltip md-direction="top">删除</md-tooltip>
              </v-btn> 
            </template>
          </v-data-table>
        </div>
        <div class="table-paging">
          <v-pagination 
            class="table-pagination" 
            prev-icon="fa fa-angle-left" 
            next-icon="fa fa-angle-right"
            color="#4caf50"
            circle 
            :value="pagination.page" 
            :length="pagination.total"
            :total-visible="1"
            @input="inputPageChange"
          ></v-pagination>
        </div>
      </v-card>
    </div>


  </div>
</template>

<script>
import CommonHeader from '@/components/DataService/CommonHeader.vue';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        value1: '',
        value2: '',
        value3: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
      selectMetaListData: [
        { text: '综合', value: 0 },
        { text: '专项', value: 1 },
      ],
      selectObjData: [{ text: '教研专家', value: 1 }, { text: '普通教室', value: 2 }],
      selectMetaListData: [{ text: '综合', value: 1 }, { text: '专项', value: 2 }],

      dateMenu: false,
      tableHeader: [
        {
          text: '#',
          align: 'start',
          sortable: false,
          value: 'index',
        },
        { text: '问卷名称', value: 'name' },
        { text: '问卷分类', value: 'type' },
        { text: '启用状态', value: 'status' },
        { text: '创建时间', value: 'createTime' },
        { text: '发布时间', value: 'publishTime' },
        { text: '结束时间', value: 'endTime' },
        { text: '回收问卷数', value: 'count' },
        { text: '条件', value: 'condition' },
        { text: '调查对象', value: 'target' },
        { text: '创建人', value: 'creator' },
        { text: '最后修改时间', value: 'updateTime' },
        { text: '操作', value: 'option', width: 150 },
      ],
      tableList: [
        {
          index: 1,
          name: '现行学习力参数的科学性',
          type: '综合',
          status: '正常',
          createTime: '2024-06-31 17:16:56',
          publishTime: '2024-07-31 17:16:56',
          endTime: '2024-09-31 17:16:56',
          count: 35,
          condition: '身份验证后填写',
          target: '教研专家\n企业专家',
          creator: 'AA',
          updateTime: '2024-07-31 17:16:56'
        },
        {
          index: 2,
          name: '信息获取力指标实施必要性',
          type: '专项',
          status: '关闭',
          createTime: '2024-06-31 17:16:56',
          publishTime: '2024-07-31 17:16:56',
          endTime: '2024-09-31 17:16:56',
          count: 35,
          condition: '身份验证后填写',
          target: '普通教师',
          creator: 'AA',
          updateTime: '2024-07-31 17:16:56'
        },
        {
          index: 3,
          name: '信息获取力指标实施必要性',
          type: '专项',
          status: '正常',
          createTime: '2024-06-31 17:16:56',
          publishTime: '2024-07-31 17:16:56',
          endTime: '2024-09-31 17:16:56',
          count: 35,
          condition: '身份验证后填写',
          target: '企业专家',
          creator: 'AA',
          updateTime: '2024-07-31 17:16:56'
        },
        {
          index: 4,
          name: '学习力新增指标征集调研',
          type: '综合',
          status: '关闭',
          createTime: '2024-06-31 17:16:56',
          publishTime: '2024-07-31 17:16:56',
          endTime: '2024-09-31 17:16:56',
          count: 35,
          condition: '身份验证后填写',
          target: '学生\n社会用户',
          creator: 'AA',
          updateTime: '2024-07-31 17:16:56'
        }
      ],
      pagination: {
        page: 1,
        total: 5,
        perPageOptions: [8, 12, 16, 20],
      },

    };
  },

  created() {

  },

  mounted() {

  },

  methods: {
    searchQuery() {
      console.log(123,this.queryParams)
      this.getTableList()
    },
    searchClear() {
      this.queryParams = {
        value1: '',
        value2: '',
        value3: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      }
    },
    inputPageChange(e) {
      this.pagination.page = e;
      this.getTableList()
    },
    getTableList() {

    },
    addClick() {
      this.$router.push({
        name: 'CreateQuestionnaire',
      });
    },
    goBack() {
      this.$router.push({
        name: 'LearningAbilityData',
      });
    },
  }
}
</script>

<style></style>

<style scoped>
.page-wrapper {
  margin: 0 15px;

  .table-data {
    .v-card {
      padding: 10px;
    }

    .table-header {
      .text-field-width {
        display: inline-block;
        width: 200px;
        margin: 0 5px 5px 0;
      }

      .select-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .date-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .v-btn {
        margin: 5px;
      }
    }

    .table-content {
      padding: 10px 0;
    }

    .table-paging {
      overflow: hidden;
      text-align: right;

      .table-pagination {
        float: right;
      }
    }
  }
}

.dimensional {
  .label-title {
    display: flex;

    .text {
      font-size: 16px;
      margin-right: 15px;
    }
  }

  .content {
    margin-top: 10px;
    .content-title {
      display: flex;
      text-align: center;
      .index {
        text-align: left;
        flex: 1;
      }
      .proportion {
        flex: 2;
      }
      .illustrate {
        flex: 6;
      }
    }
    .content-list {
      display: flex;
      margin-bottom: 10px;
      .text {
        flex: 1;
        text-align: left;
      }
      .num-input {
        flex: 2;
        margin: 0 5px;
      }
      .rich-text {
        flex: 6;
      }
      .delete {
        cursor: pointer;
        height: 100%;
        margin: 0 5px;
      }
    }
  }

}
</style>